import Component from './Options.vue';

export default {
  install(Vue) {
    Vue.component('BkfActionOptions', Component);
  },
};
